export const keywords =
  'itr filing for nri, nri itr filing, filing itr for nri​, nri itr filing india, income tax return filing for nri, income tax return filing for non resident indian, cleartax itr filing for nri, itr filing for foreign income, income tax return filing for foreign income, cleartax itr filing for foreign income';

export const canonical =
  'https://cleartax.in/itr-filing-for-nri-and-foreign-income';

export const description =
  'ITR Filing for NRIs and Foreign Income: File Income Tax Return for non resident Indian and foreign income easily with ClearTax.';

export const pageTitle = 'ITR Filing for NRIs & Foreign Income | ClearTax';
